const { initialState } = window;
let { translate } = initialState;
translate = JSON.parse(translate);
export default (state = translate, action) => {
	switch (action.type) {
	case "A":
		return state;
	default:
		return state;
	}
};
